import { Button, Div, H3, lightTheme } from '@vgrubs/components';
import { ReactNode, useState } from 'react';
import { ModalPortal } from '../../../components/modal/modalPortal';

type Props = {
  isOpen: boolean;
  closeModal: () => void;
  title: string;
  children: ReactNode;
  confirmLabel: string;
  /** Resolves true when the action went through, which closes the modal. */
  onConfirm: () => Promise<boolean>;
};

/**
 * Yes / no gate in front of the menu actions that publish to providers on
 * their own (set as default, delete). Opened from the options dropdown, so it
 * goes through the portal.
 */
export const MenuConfirmModal = ({
  isOpen,
  closeModal,
  title,
  children,
  confirmLabel,
  onConfirm,
}: Props) => {
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    setLoading(true);
    const ok = await onConfirm();
    setLoading(false);
    if (ok) closeModal();
  };

  return (
    <ModalPortal isOpen={isOpen} closeModal={closeModal} logo={false}>
      <H3 $mb="24" $center $color={lightTheme.primary}>
        {title}
      </H3>
      <Div $textAlignCenter>{children}</Div>
      <Div $flex $gap="16px" $mt="24">
        <Button
          $selected
          $w="100%"
          $loading={loading}
          disabled={loading}
          onClick={handleConfirm}
        >
          {confirmLabel}
        </Button>
        <Button $selected $gray $w="100%" onClick={closeModal}>
          Cancel
        </Button>
      </Div>
    </ModalPortal>
  );
};
